import { render } from "./CurrentSkeleton.vue?vue&type=template&id=9a5e6d34&scoped=true"
import script from "./CurrentSkeleton.vue?vue&type=script&lang=js"
export * from "./CurrentSkeleton.vue?vue&type=script&lang=js"

import "./CurrentSkeleton.vue?vue&type=style&index=0&id=9a5e6d34&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5e6d34"]])

export default __exports__